"use client"

import { StoriesSectionDto } from "api"
import ChevronIcon from "./ChevronIcon"
import FeaturedStory from "./FeaturedStory"
import StoryCard from "./StoryCard"
import {
  AllStoriesLink,
  Editorial,
  Eyebrow,
  HeadText,
  Headline,
  MobileOnly,
  SecHead,
  SideColumn,
  StoriesWrap,
  Wrap,
} from "./storiesSection.styled"

type Props = { data?: StoriesSectionDto | null }

const StoriesSection = ({ data }: Props) => {
  // No featured story → nothing to show.
  if (!data?.featuredStory) return null
  const sideStories = data.sideStories ?? []

  return (
    <StoriesWrap dir="rtl" aria-label={data.sectionHeadline || "Mazda Stories"}>
      <SecHead>
        <HeadText>
          {data.sectionLabel && (
            <Eyebrow dir="auto">{data.sectionLabel}</Eyebrow>
          )}
          {data.sectionHeadline && (
            <Headline dir="auto">{data.sectionHeadline}</Headline>
          )}
        </HeadText>
        {data.allStoriesUrl && (
          <AllStoriesLink href={data.allStoriesUrl}>
            {data.allStoriesLabel || "לכל הסיפורים"}
            <ChevronIcon size={14} />
          </AllStoriesLink>
        )}
      </SecHead>

      <Wrap>
        <Editorial>
          {/* Desktop: big overlay featured (right). Hidden ≤820px. */}
          <FeaturedStory story={data.featuredStory} revealDelay={0} />
          <SideColumn>
            {/* Mobile: featured renders as a stacked card, first in the column. */}
            <MobileOnly>
              <StoryCard story={data.featuredStory} revealDelay={0} />
            </MobileOnly>
            {sideStories.map((story, i) => (
              <StoryCard
                key={story.id}
                story={story}
                revealDelay={(i + 1) * 120}
              />
            ))}
          </SideColumn>
        </Editorial>
      </Wrap>
    </StoriesWrap>
  )
}

export default StoriesSection
